(function () {
  'use strict';
  if (window.KMStorefrontSpeed) return;
  var pending = new Map(), memory = new Map(), queue = [], active = 0;
  var ttl = 120000, prefix = 'km-public-speed-v3:', enabled = true, epoch = 0;
  function editing() {
    return !!(window.Shopify && window.Shopify.designMode) ||
      new URLSearchParams(location.search).has('preview_theme_id');
  }
  function copy(value) { return typeof value === 'string' ? value : JSON.parse(JSON.stringify(value)); }
  function context() {
    return new URLSearchParams(location.search).get('preview_theme_id') || '';
  }
  function isEmptyCatalog(value, source) {
    if (!value || value.catalogVersion !== 1 || !value.category ||
        typeof value.category.title !== 'string' || !value.category.title.trim() ||
        typeof value.category.url !== 'string' || value.total !== 0 ||
        !Array.isArray(value.articles) || value.articles.length || value.nextPage !== null) return false;
    try {
      var url = new URL(source, location.origin), category = new URL(value.category.url, location.origin);
      return url.origin === location.origin && category.origin === location.origin &&
        !/\/tagged\//.test(url.pathname) && category.pathname === url.pathname &&
        value.category.handle === decodeURIComponent(url.pathname.split('/').pop());
    } catch (_) { return false; }
  }
  function cacheable(value, type) {
    if (type === 'xml') {
      var xml = new DOMParser().parseFromString(value, 'application/xml');
      return !xml.querySelector('parsererror') && /^(sitemapindex|urlset)$/.test(xml.documentElement.localName);
    }
    if (value && typeof value['replit-blog-post-list-data'] === 'string') {
      try {
        var doc = new DOMParser().parseFromString(value['replit-blog-post-list-data'], 'text/html');
        var node = doc.querySelector('template[data-km-public-catalog]');
        if (node) return cacheable(JSON.parse(node.content.textContent), 'json');
        var scripts = doc.querySelectorAll('script[data-km-post-tag-data]');
        return scripts.length === 1 && cacheable(JSON.parse(scripts[0].textContent), 'json');
      } catch (_) { return false; }
    }
    return value && Array.isArray(value.articles) && Number.isInteger(value.total) && value.total >= 0 &&
      (value.nextPage === null || Number.isInteger(value.nextPage) && value.nextPage > 1) &&
      value.articles.every(function (item) {
        return item && item.id && typeof item.title === 'string' && Array.isArray(item.tags);
      });
  }
  function get(key) {
    if (!enabled || editing()) return null;
    var item = memory.get(key);
    try { if (!item) item = JSON.parse(sessionStorage.getItem(prefix + key)); } catch (_) {}
    if (!item || item.expires <= Date.now()) return null;
    return item;
  }
  function put(key, value, type, generation, rawURL) {
    if (!enabled || editing() || generation !== epoch || !cacheable(value, type)) return;
    var item = {expires:Date.now() + ttl, value:value}, serialized = JSON.stringify(item);
    if (serialized.length > 500000) return;
    if (memory.size >= 64) memory.delete(memory.keys().next().value);
    memory.set(key, item);
    try {
      // Bound stored catalog bytes; quota failures never block article rendering.
      var keys = [], bytes = serialized.length;
      for (var i = 0; i < sessionStorage.length; i++) {
        var candidate = sessionStorage.key(i);
        if (candidate.indexOf(prefix) === 0) {
          keys.push(candidate); bytes += (sessionStorage.getItem(candidate) || '').length;
        }
      }
      while (keys.length && (keys.length >= 64 || bytes > 1500000)) {
        var oldest = keys.shift(); bytes -= (sessionStorage.getItem(oldest) || '').length;
        sessionStorage.removeItem(oldest);
      }
      sessionStorage.setItem(prefix + key, serialized);
    } catch (_) {}
    // Only a complete UNFILTERED native catalog may establish an empty Blog.
    // Zero matches for one Tag must never imply that a Blog has no articles.
    if (type === 'json' && isEmptyCatalog(value, rawURL)) {
      var url = new URL(rawURL, location.origin);
      if (!/\/tagged\//.test(url.pathname)) {
        var emptyKey = 'empty:' + context() + ':' + url.pathname;
        var empty = {expires:Date.now() + ttl,value:true};
        memory.set(emptyKey,empty);
        try { sessionStorage.setItem(prefix + emptyKey,JSON.stringify(empty)); } catch (_) {}
      }
    }
  }
  function invalidate() {
    epoch++; memory.clear();
    try {
      for (var i = sessionStorage.length - 1; i >= 0; i--) {
        var key = sessionStorage.key(i);
        if (key.indexOf(prefix) === 0) sessionStorage.removeItem(key);
      }
    } catch (_) {}
  }
  function aborted() { return new DOMException('Aborted', 'AbortError'); }
  function drain() {
    while (active < 6 && queue.length) {
      var flight = queue.shift();
      if (!flight.listeners.size) { if (pending.get(flight.key) === flight) pending.delete(flight.key); continue; }
      active++; flight.started = true;
      (async function (job) {
        var timeout = false, timer = setTimeout(function () { timeout = true; job.controller.abort(); }, 20000);
        var value, failure;
        try {
          var response = await fetch(job.url, {
            signal:job.controller.signal, credentials:'same-origin', priority:'high',
            headers:{Accept:job.type === 'xml' ? 'application/xml,text/xml' : 'application/json'}
          });
          if (!response.ok) {
            failure = Error('Public Blog data HTTP ' + response.status + '. Please retry.');
            failure.httpStatus = response.status; throw failure;
          }
          var text = await response.text();
          if (job.type === 'xml') value = text;
          else {
            try { value = JSON.parse(text); }
            catch (_) {
              failure = Error('The Blog endpoint returned HTML or invalid JSON, not article data.');
              failure.catalogFormat = true; throw failure;
            }
          }
          put(job.key, value, job.type, job.epoch, job.url);
        } catch (error) { failure = timeout ? Error('Public Blog data timed out. Please retry.') : error; }
        finally {
          clearTimeout(timer); active--;
          if (pending.get(job.key) === job) pending.delete(job.key);
          job.listeners.forEach(function (listener) { listener.finish(failure, value); });
          drain();
        }
      })(flight);
    }
  }
  function request(raw, signal, type) {
    if (signal && signal.aborted) return Promise.reject(aborted());
    var url = new URL(raw, location.href);
    if (url.origin !== location.origin) return Promise.reject(Error('Only same-origin Blog data may be loaded.'));
    url.searchParams.sort();
    var key = context() + ':' + type + ':' + url.href, cached = get(key);
    if (cached) return Promise.resolve(copy(cached.value));
    var flight = pending.get(key);
    if (!flight || flight.controller.signal.aborted) {
      flight = {key:key,url:url.href,type:type,controller:new AbortController(),listeners:new Set(),epoch:epoch,started:false};
      pending.set(key, flight); queue.push(flight);
    }
    return new Promise(function (resolve, reject) {
      var done = false;
      var listener = {finish:function (error, value) {
        if (done) return; done = true;
        if (signal) signal.removeEventListener('abort', cancel);
        flight.listeners.delete(listener);
        if (error) reject(error); else resolve(copy(value));
      }};
      function cancel() {
        listener.finish(aborted());
        if (!flight.listeners.size) flight.controller.abort();
      }
      flight.listeners.add(listener);
      if (signal) signal.addEventListener('abort', cancel, {once:true});
      drain();
    });
  }
  function selectSitemaps(locations, rootUrl) {
    var root = new URL(rootUrl || '/', location.origin).pathname.replace(/\/$/, '');
    var groups = new Map();
    locations.forEach(function (raw) {
      var url = new URL(raw, location.origin), basename = url.pathname.split('/').pop();
      var key = basename + url.search;
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(url);
    });
    var selected = [];
    groups.forEach(function (group) {
      var current = group.find(function (url) {
        return url.pathname === root + '/' + url.pathname.split('/').pop();
      });
      (current ? [current] : group).forEach(function (url) {
        selected.push(new URL(url.pathname + url.search, location.origin).href);
      });
    });
    return Array.from(new Set(selected));
  }
  async function pages(first, read, signal) {
    function metadata(data) {
      if (!data || !Array.isArray(data.articles) || !Number.isInteger(data.total) || data.total < 0) {
        throw Error('Blog catalog format is invalid.');
      }
    }
    metadata(first);
    var size = first.articles.length, total = first.total;
    var count = size ? Math.ceil(total / size) : 1;
    if (count > 500 || (!size && total) || first.nextPage !== (count > 1 ? 2 : null)) {
      throw Error('Blog pagination is incomplete or invalid.');
    }
    var result = [first], cursor = 2;
    await Promise.all(Array.from({length:Math.min(4, count - 1)}, async function () {
      while (cursor <= count) {
        if (signal.aborted) throw aborted();
        var page = cursor++, data = await read(page);
        metadata(data);
        if (data.total !== total || data.nextPage !== (page < count ? page + 1 : null) ||
          data.articles.length !== Math.min(size, total - (page - 1) * size)) {
          throw Error('Blog pagination is incomplete or changed during loading.');
        }
        result[page - 1] = data;
      }
    }));
    var ids = new Set();
    result.forEach(function (data) {
      data.articles.forEach(function (item) {
        if (!item || !item.id || ids.has(String(item.id))) throw Error('Blog pagination repeated or invalidated an article.');
        ids.add(String(item.id));
      });
    });
    if (ids.size !== total) throw Error('Blog catalog is incomplete; no partial results were displayed.');
    return result;
  }
  function skeletons() {
    if (document.getElementById('km-public-loading-skeletons')) return;
    var style = document.createElement('style'); style.id = 'km-public-loading-skeletons';
    style.textContent = '.km-post-list[data-tag-state="loading"] [data-post-feedback]::after,' +
      '.km-article-hub[aria-busy="true"] [data-aa-grid]::before{' +
      'content:"";display:block;grid-column:1/-1;height:280px;margin-top:16px;border-radius:4px;' +
      'background:linear-gradient(90deg,#ededed 0 31%,transparent 31% 34%,#ededed 34% 65%,transparent 65% 68%,#ededed 68% 100%)}' +
      '@media(max-width:767px){.km-post-list[data-tag-state="loading"] [data-post-feedback]::after,' +
      '.km-article-hub[aria-busy="true"] [data-aa-grid]::before{height:220px;' +
      'background:linear-gradient(90deg,#ededed 0 48%,transparent 48% 52%,#ededed 52% 100%)}}';
    document.head.appendChild(style);
  }
  window.KMStorefrontSpeed = {
    request:request, selectSitemaps:selectSitemaps, pages:pages, invalidate:invalidate, isEmptyCatalog:isEmptyCatalog,
    emptyBlog:function (source) { return !!get('empty:' + context() + ':' + new URL(source,location.origin).pathname); },
    prefersSection:function (source) { return !!get('provider:' + context() + ':' + source); },
    rememberSection:function (source) {
      if (!enabled || editing()) return;
      var key = 'provider:' + context() + ':' + source;
      var item = {expires:Date.now() + ttl,value:true};
      memory.set(key,item);
      try { sessionStorage.setItem(prefix + key,JSON.stringify(item)); } catch (_) {}
    },
    setCacheEnabled:function (value) { enabled = !!value; if (!enabled) invalidate(); }
  };
  window.KMStorefrontSpeed.startEarly = function (selector, scan, gate) {
    var seen = new WeakSet(), observer;
    function run() {
      document.querySelectorAll(selector + '[data-km-early] [data-km-render-ready]').forEach(function (marker) {
        var root = marker.closest(selector);
        if (!root || seen.has(root) || (gate && !gate(root))) return;
        seen.add(root); scan(root);
      });
    }
    if (document.readyState === 'loading') {
      observer = new MutationObserver(run);
      observer.observe(document, {childList:true,subtree:true});
      document.addEventListener('DOMContentLoaded',function () { run(); observer.disconnect(); },{once:true});
    }
    run();
  };
  window.KMStorefrontSpeed.responsiveImage = function (image, source) {
    var url = new URL(source,location.href);
    if ((url.origin === location.origin && url.pathname.indexOf('/cdn/shop/') === 0) ||
      (url.hostname === 'cdn.shopify.com' && url.pathname.indexOf('/s/files/') === 0)) {
      image.loading = 'lazy';
      image.sizes = 'auto, (max-width:767px) 48vw, (max-width:1200px) 30vw, 400px';
      image.srcset = [360,540,720,900].map(function (width) {
        var sized = new URL(url); sized.searchParams.set('width',String(width));
        return sized.href + ' ' + width + 'w';
      }).join(', ');
      url.searchParams.set('width','720');
    }
    image.src = url.href;
  };
  skeletons();
})();

;
/* Shared public-data contract. No API keys, admin endpoints or customer data. */
(function () {
  'use strict';
  if (window.KMBlogCatalog) return;
  var speed = window.KMStorefrontSpeed;
  var prefix = 'km-blog-catalog-v3:', ttl = 120000;
  function editing() {
    return !!(window.Shopify && window.Shopify.designMode) ||
      new URLSearchParams(location.search).has('preview_theme_id');
  }
  function key(kind, config) {
    // The source config, origin, locale and theme define identity, not the current category page.
    var theme = window.Shopify && window.Shopify.theme ? String(window.Shopify.theme.id || '') : '';
    return prefix + location.origin + ':' + theme + ':' + kind + ':' + JSON.stringify(config);
  }
  function snapshot(kind, config) {
    if (editing()) return null;
    try {
      var name = key(kind, config), saved = JSON.parse(sessionStorage.getItem(name));
      if (!saved || saved.expires <= Date.now()) { sessionStorage.removeItem(name); return null; }
      if (!saved.value || !Array.isArray(saved.value.articles)) return null;
      return saved.value;
    } catch (_) { return null; }
  }
  function save(kind, config, value) {
    if (editing()) return;
    try {
      var name = key(kind, config), text = JSON.stringify({expires:Date.now()+ttl,value:value});
      if (text.length > 900000) return;
      var keys = [], bytes = text.length;
      for (var i = 0; i < sessionStorage.length; i++) {
        var candidate = sessionStorage.key(i);
        if (candidate.indexOf(prefix) === 0) {
          keys.push(candidate);
          bytes += (sessionStorage.getItem(candidate) || '').length;
        }
      }
      while (keys.length && (keys.length >= 12 || bytes > 2000000)) {
        var removed = keys.shift();
        bytes -= (sessionStorage.getItem(removed) || '').length;
        sessionStorage.removeItem(removed);
      }
      sessionStorage.setItem(name, text);
    } catch (_) { /* Storage disabled/full: normal loading still works. */ }
  }
  var invalidateOriginal = speed.invalidate;
  speed.invalidate = function () {
    invalidateOriginal();
    try {
      for (var i = sessionStorage.length-1; i >= 0; i--) {
        var name = sessionStorage.key(i);
        if (name.indexOf(prefix) === 0) sessionStorage.removeItem(name);
      }
    } catch (_) {}
  };
  function local(source) {
    var url = new URL(source, location.href);
    if (url.origin !== location.origin || !/\/blogs\/[^/]+\/?$/.test(url.pathname)) {
      throw Error('A valid same-store Blog source is required.');
    }
    url.pathname = url.pathname.replace(/\/$/, '');
    url.search = '';
    return url;
  }
  function validate(data, source) {
    if (!data || data.catalogVersion !== 3 || !data.category ||
        typeof data.category.title !== 'string' || !Array.isArray(data.category.tags) ||
        !Number.isInteger(data.total) || data.total < 0 ||
        !Array.isArray(data.articles) ||
        !(data.nextPage === null || Number.isInteger(data.nextPage) && data.nextPage > 1)) {
      throw Error('Install the updated sections/replit-blog-post-list-data.liquid in the same live/preview theme as both JS files.');
    }
    var expected = local(source), returned = local(data.category.url);
    // blog.url may be unprefixed on a market URL. Match the handle, preserving requested locale.
    if (data.category.handle !== decodeURIComponent(expected.pathname.split('/').pop()) ||
        returned.pathname.split('/').pop() !== expected.pathname.split('/').pop()) {
      throw Error('The Blog catalog returned a different category. No incorrect articles were displayed.');
    }
    data.articles.forEach(function (article) {
      if (!article || typeof article.id !== 'string' || !article.id ||
          typeof article.title !== 'string' || typeof article.url !== 'string' ||
          typeof article.excerpt !== 'string' || typeof article.searchText !== 'string' ||
          !Array.isArray(article.tags) || article.tags.some(function (tag) { return typeof tag !== 'string'; }) ||
          !Number.isSafeInteger(article.createdAt) || article.createdAt <= 0 ||
          !Number.isSafeInteger(article.publishedAt) || article.publishedAt <= 0 ||
          !Number.isFinite(article.recommendationPriority)) {
        throw Error('The shared Blog catalog contains invalid article data.');
      }
      if (new URL(article.url,location.origin).origin !== location.origin) throw Error('External article URL rejected.');
    });
    return data;
  }
  async function confirmUnavailable(source, signal) {
    var url = local(source);
    var saved = snapshot('unavailable-blog',url.pathname);
    if (saved) return true;
    try {
      // A no-context data payload is NOT proof that the Blog is gone.
      // Confirm the ordinary public Blog route returns HTTP 404.
      await speed.request(url.href,signal,'xml');
    } catch (error) {
      if (error.httpStatus === 404) {
        save('unavailable-blog',url.pathname,{articles:[]});
        return true;
      }
      throw error;
    }
    throw Error('The Blog URL is public, but its data response has no Blog context. Check the shared data section for '+url.pathname+'.');
  }
  async function read(source, page, signal) {
    var url = local(source);
    url.searchParams.set('sections','replit-blog-post-list-data');
    url.searchParams.set('page',String(page));
    var preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (!preview && editing() && window.Shopify && Shopify.theme) preview = String(Shopify.theme.id);
    if (preview && /^\d+$/.test(preview)) url.searchParams.set('preview_theme_id',preview);
    var response;
    try { response = await speed.request(url.href, signal, 'json'); }
    catch (error) {
      if (error.httpStatus === 404 && await confirmUnavailable(source,signal)) {
        return {unavailable:true,total:0,nextPage:null,articles:[],category:null};
      }
      throw error;
    }
    var html = response && response['replit-blog-post-list-data'];
    if (typeof html !== 'string') throw Error('The shared data section is missing from this theme. Install sections/replit-blog-post-list-data.liquid.');
    var doc = new DOMParser().parseFromString(html,'text/html');
    var node = doc.querySelector('template[data-km-public-catalog]');
    var text;
    if (node) text = node.content.textContent;
    else {
      node = doc.querySelector('script[data-km-post-tag-data]');
      if (node) text = node.textContent;
    }
    if (!text) throw Error('The shared data section has no catalog payload. Replace it with the data Liquid from this ZIP.');
    var data;
    try { data = JSON.parse(text); }
    catch (_) { throw Error('The shared data section returned invalid JSON.'); }
    if (data && data.error === 'This catalog must be requested on a valid Blog URL.') {
      if (await confirmUnavailable(source,signal)) {
        return {unavailable:true,total:0,nextPage:null,articles:[],category:null};
      }
    }
    return validate(data,source);
  }
  async function catalog(source, signal) {
    var first = await read(source,1,signal);
    if (first.unavailable) return {unavailable:true,category:null,articles:[]};
    var batches = await speed.pages(first,function (page) { return read(source,page,signal); },signal);
    var articles = [];
    batches.forEach(function (batch) {
      if (batch.category.handle !== first.category.handle) throw Error('The Blog changed while loading.');
      articles.push.apply(articles,batch.articles);
    });
    return {category:first.category, articles:articles};
  }
  window.KMBlogCatalog = {read:read,catalog:catalog,snapshot:snapshot,save:save,version:3};
})();

;
(function(){"use strict";if(window.__kmRecommendedHubLoaded)return;window.__kmRecommendedHubLoaded=!0;window.__kmRecommendedSpeedVersion="speed-3";var instances=new WeakMap,paramNames=["km_tag","km_category","km_q","km_section"];function decode(value){var node=document.createElement("textarea");return node.innerHTML=String(value||"").replace(/</g,"&lt;"),node.value}function normalize(value){return decode(value).normalize("NFKC").toLocaleLowerCase().trim()}function exclusionSet(value){return new Set(String(value||"").split(/\r?\n/).map(normalize).filter(Boolean))}function localURL(raw){var url=new URL(raw,window.location.href);if(!/^https?:$/.test(url.protocol)&&!(window.location.protocol==="file:"&&url.protocol==="file:"))throw new Error("Invalid article or Blog URL.");return url.pathname+url.search}function parseXML(text){var xml=new DOMParser().parseFromString(text,"application/xml");if(xml.querySelector("parsererror"))throw new Error("The store sitemap could not be read.");return xml}async function mapLimit(items,limit,callback){var cursor=0,results=new Array(items.length);async function worker(){for(;cursor<items.length;){var index=cursor++;results[index]=await callback(items[index])}}return await Promise.all(Array.from({length:Math.min(limit,items.length)},worker)),results}async function request(url,signal,json){return window.KMStorefrontSpeed.request(url,signal,json?"json":"xml")}async function discover(config,signal){if(config.blogs&&config.blogs.length)return Array.from(new Set(config.blogs.map(function(blog){return localURL(blog.url)})));var index=parseXML(await request("/sitemap.xml",signal,!1)),locations=Array.from(index.getElementsByTagName("sitemap")).map(function(node){var loc=node.getElementsByTagName("loc")[0];return loc&&loc.textContent.trim()}).filter(function(url){return url&&/\/sitemap_blogs[^/]*\.xml(?:\?|$)/i.test(url)}),handles=new Set;locations=window.KMStorefrontSpeed.selectSitemaps(locations,config.rootUrl);await mapLimit(locations,3,async function(url){var xml=parseXML(await request(localURL(url),signal,!1));Array.from(xml.getElementsByTagName("url")).forEach(function(node){var loc=node.getElementsByTagName("loc")[0];if(loc){var match=new URL(loc.textContent.trim(),window.location.href).pathname.match(/\/blogs\/([^/]+)/);match&&handles.add(match[1])}})});var prefix=(config.rootUrl||"/").replace(/\/$/,"");return Array.from(handles).map(function(handle){return prefix+"/blogs/"+handle})}
async function readBlog(source,signal,excluded) {
  var base = new URL(localURL(source),location.href);
  base.searchParams.set('view','km-article-recommended');
  var preview = new URLSearchParams(location.search).get('preview_theme_id');
  if (!preview && window.Shopify && Shopify.designMode && Shopify.theme) preview=String(Shopify.theme.id);
  if (preview) base.searchParams.set('preview_theme_id',preview);
  async function read(page) {
    return window.KMBlogCatalog.read(source,page,signal);
  }
  var first=await read(1);if(first.unavailable)return {unavailable:true,category:null,articles:[]};var category={handle:first.category.handle,title:decode(first.category.title),
    url:localURL(first.category.url),tags:Array.isArray(first.category.tags)?first.category.tags:[]};
  if(excluded && (excluded.has(normalize(category.title)) || excluded.has(normalize(category.handle)))) {
    return {category:category,articles:[]};
  }
  var batches=await window.KMStorefrontSpeed.pages(first,read,signal), articles=[];
  batches.forEach(function(data) {
    if(data.category.handle!==category.handle) throw Error('The Blog catalog changed while loading. Please retry.');
    data.articles.forEach(function(article) {
      if(!article.id || !article.title || !article.url || !Array.isArray(article.tags)) throw Error('An article is missing required catalog data.');
      var item={id:String(article.id),title:decode(article.title),url:localURL(article.url),
        excerpt:decode(article.excerpt),tags:article.tags.map(String),category:category.handle,
        publishedAt:Number(article.publishedAt)||0,image:article.image||'',imageAlt:decode(article.imageAlt||article.title),
        recommendationPriority:article.recommendationPriority===2?2:article.recommendationPriority===1?1:0};
      item.search=normalize([item.title,item.excerpt,article.searchText,item.tags.join(' '),category.title].join(' '));
      articles.push(item);
    });
  });
  return {category:category,articles:articles};
}
function init(root){if(root.hasAttribute("data-km-early")&&!root.querySelector("[data-km-render-ready]"))return;if(instances.has(root))return;var configNode=root.querySelector("[data-aa-config]"),grid=root.querySelector("[data-aa-grid]"),template=root.querySelector("[data-aa-card-template]");if(!configNode||!grid||!template)return;var tabs=root.querySelector("[data-aa-tabs]"),search=root.querySelector("[data-aa-search]"),form=root.querySelector("[data-aa-form]"),hint=root.querySelector("[data-aa-hint]"),message=root.querySelector("[data-aa-message]"),retry=root.querySelector("[data-aa-retry]"),more=root.querySelector("[data-aa-more]"),loadWrap=root.querySelector("[data-aa-load-wrap]"),tagsNode=root.querySelector("[data-aa-tags]"),status=root.querySelector("[data-aa-status]"),tagState=root.querySelector("[data-aa-tag-state]"),activeTag=root.querySelector("[data-aa-active-tag]"),clearTag=root.querySelector("[data-aa-clear-tag]"),heading=root.querySelector("h2"),allLabel=tabs.querySelector('[data-aa-category=""]').textContent,articles=[],categories=[],state={category:"",tag:"",query:""},initial=Math.max(1,Number(root.dataset.initial)||6),batch=Math.max(1,Number(root.dataset.batch)||6),limit=initial,controller=null,inputTimer=null,ready=!1,destroyed=!1,excludedCategories=new Set,excludedTags=new Set,alignmentFrame=null,observedWidth=-1;function alignTitles(){if(!(destroyed||!grid.clientWidth)){var titles=Array.prototype.slice.call(grid.querySelectorAll("[data-aa-title]"));titles.forEach(function(title){title.style.removeProperty("--km-ah-title-height")});var rows=new Map;titles.forEach(function(title){var top=Math.round(title.closest(".km-article-hub__card").getBoundingClientRect().top),row=rows.get(top)||{titles:[],height:0};row.titles.push(title),row.height=Math.max(row.height,Math.ceil(title.getBoundingClientRect().height)),rows.set(top,row)}),rows.forEach(function(row){row.titles.forEach(function(title){title.style.setProperty("--km-ah-title-height",row.height+"px")})})}}function scheduleAlignment(){destroyed||alignmentFrame!==null||(alignmentFrame=window.requestAnimationFrame(function(){alignmentFrame=null,alignTitles()}))}var alignmentObserver=window.ResizeObserver?new ResizeObserver(function(entries){var width=entries[0].contentRect.width;Math.abs(width-observedWidth)>.1&&(observedWidth=width,scheduleAlignment())}):null;function categoryIsVisible(category){return!excludedCategories.has(normalize(category.handle))&&!excludedCategories.has(normalize(category.title))}function messageText(text){message.textContent=text,message.hidden=!text}function readState(){var params=new URLSearchParams(window.location.search);params.get("km_section")&&params.get("km_section")!==root.id?state={category:"",tag:"",query:""}:state={category:params.get("km_category")||"",tag:params.get("km_tag")||"",query:params.get("km_q")||""},categories.some(function(category){return category.handle===state.category&&categoryIsVisible(category)})||(state.category=""),excludedTags.has(normalize(state.tag))&&(state.tag=""),search.value=state.query}function stateURL(nextState){var url=new URL(window.location.href);return paramNames.forEach(function(key){url.searchParams.delete(key)}),nextState.tag&&url.searchParams.set("km_tag",nextState.tag),nextState.category&&url.searchParams.set("km_category",nextState.category),nextState.query&&url.searchParams.set("km_q",nextState.query),(nextState.tag||nextState.category||nextState.query)&&url.searchParams.set("km_section",root.id),url.hash=root.id,url}function saveState(push){var url=stateURL(state);try{window.history[push?"pushState":"replaceState"]({},"",url)}catch{}}function render(){if(!(!ready||destroyed)){var words=normalize(state.query).split(/\s+/).filter(Boolean),matches=articles.filter(function(article){return(!state.category||article.category===state.category)&&(!state.tag||article.tags.indexOf(state.tag)!==-1)&&words.every(function(word){return article.search.indexOf(word)!==-1})});tabs.querySelectorAll("[data-aa-category]").forEach(function(button){var active=button.dataset.aaCategory===state.category;button.classList.toggle("is-active",active),button.setAttribute("aria-pressed",String(active))}),grid.replaceChildren(),matches.slice(0,limit).forEach(function(article){var fragment=template.content.cloneNode(!0),link=fragment.querySelector("[data-aa-link]");link.href=article.url,fragment.querySelector("[data-aa-title]").textContent=article.title;var excerpt=fragment.querySelector("[data-aa-excerpt]");excerpt.textContent=article.excerpt,excerpt.hidden=!article.excerpt;var image=fragment.querySelector("[data-aa-image]");if(image.alt=article.imageAlt,article.image){var url=new URL(article.image,window.location.href);/^https?:$/.test(url.protocol)||window.location.protocol==="file:"?window.KMStorefrontSpeed.responsiveImage(image,article.image):image.hidden=!0}else image.hidden=!0;image.loading="lazy",grid.appendChild(fragment)}),messageText(matches.length?"":"No articles match this selection. Try another keyword or choose All."),loadWrap.hidden=matches.length<=limit,more.disabled=matches.length<=limit,tagState&&(tagState.hidden=!state.tag),activeTag&&(activeTag.textContent=state.tag),status&&(status.textContent="Showing "+Math.min(limit,matches.length)+" of "+matches.length+" articles."),alignTitles()}}function buildFilters(){tabs.replaceChildren(),[{handle:"",title:allLabel}].concat(categories.filter(categoryIsVisible)).forEach(function(category,index){var option=document.createElement("span");if(option.className="km-article-hub__tab-option",index){var separator=document.createElement("span");separator.className="km-article-hub__tab-separator",separator.textContent="|",separator.setAttribute("aria-hidden","true"),option.appendChild(separator)}var button=document.createElement("button");button.type="button",button.className="km-article-hub__tab",button.dataset.aaCategory=category.handle,button.textContent=category.title,option.appendChild(button),tabs.appendChild(option)});var allTags=new Set;categories.forEach(function(category){category.tags.forEach(function(tag){allTags.add(String(tag))})}),articles.forEach(function(article){article.tags.forEach(function(tag){allTags.add(tag)})}),tagsNode.replaceChildren(),Array.from(allTags).filter(function(tag){return!excludedTags.has(normalize(tag))}).sort(function(a,b){return a.localeCompare(b)}).forEach(function(tag){var link=document.createElement("a");link.className="km-article-hub__tag",link.dataset.aaTag=tag,link.textContent=tag,link.href=stateURL({tag,category:"",query:""}).toString(),tagsNode.appendChild(link)})}
function publishCatalogs(catalogs) {
  catalogs=catalogs.filter(function(catalog){return !catalog.unavailable;});
  categories=catalogs.map(function(catalog){return catalog.category});var seen=new Set;articles=[],catalogs.forEach(function(catalog){catalog.articles.forEach(function(article){seen.has(article.id)||(seen.add(article.id),articles.push(article))})}),articles.sort(function(a,b){var titleOrder=a.title.localeCompare(b.title),tieBreak=titleOrder||a.id.localeCompare(b.id);if(root.dataset.sort==="title")return tieBreak;if(root.dataset.sort==="recommended"){var priorityOrder=b.recommendationPriority-a.recommendationPriority;if(priorityOrder)return priorityOrder}var dateOrder=root.dataset.sort==="oldest"?a.publishedAt-b.publishedAt:b.publishedAt-a.publishedAt;return dateOrder||tieBreak}),buildFilters();var typedQuery=search.value;readState(),typedQuery&&(state={category:"",tag:"",query:typedQuery},search.value=typedQuery),ready=!0,render();
  root.setAttribute("aria-busy","false");
}
async function load(event) {
  if(event)window.KMStorefrontSpeed.invalidate();
  if(controller)controller.abort();
  var config;
  try {
    config=JSON.parse(configNode.textContent);
    excludedCategories=exclusionSet(config.excludedCategories);
    excludedTags=exclusionSet(config.excludedTags);
    if(!event) {
      var saved=window.KMBlogCatalog.snapshot('recommended',[config,root.dataset.sort]);
      if(saved) {
        try { publishCatalogs(saved.articles); return; }
        catch (_) { window.KMStorefrontSpeed.invalidate(); }
      }
    }
  } catch(error) { messageText(error.message);retry.hidden=false;return; }
  controller=new AbortController();
  var loadController=controller,timedOut=false;
  var deadline=setTimeout(function(){timedOut=true;loadController.abort()},30000);
  ready=false;root.setAttribute("aria-busy","true");more.disabled=true;retry.hidden=true;
  loadWrap.hidden=true;messageText("Loading...");
  try {
    var sources=await discover(config,controller.signal);
    var catalogs=await mapLimit(sources,6,function(source){return readBlog(source,loadController.signal,excludedCategories)});
    if(destroyed||loadController!==controller)return;
    publishCatalogs(catalogs);
    window.KMBlogCatalog.save('recommended',[config,root.dataset.sort],{articles:catalogs});
  }catch(error){
    if(destroyed||loadController!==controller)return;
    if(error.name==="AbortError"&&!timedOut)return;
    window.KMStorefrontSpeed.invalidate();
    if(timedOut)error=Error("Article loading timed out. Please retry.");
    controller.abort();messageText(error.message);retry.hidden=false;
  }finally{
    clearTimeout(deadline);
    if(!destroyed&&loadController===controller)root.setAttribute("aria-busy","false");
  }
}
function onCategory(event){var button=event.target.closest("[data-aa-category]");!ready||!button||!tabs.contains(button)||(window.clearTimeout(inputTimer),state={category:button.dataset.aaCategory,tag:"",query:""},search.value="",limit=initial,saveState(!0),render())}function globalSearch(){state.category="",state.tag=""}function onFocus(){hint&&(hint.hidden=!1),ready&&(globalSearch(),limit=initial,saveState(!1),render())}function onBlur(){hint&&(hint.hidden=!0)}function searchNow(){ready&&(globalSearch(),state.query=search.value,limit=initial,saveState(!1),render())}function onInput(){window.clearTimeout(inputTimer),inputTimer=window.setTimeout(searchNow,150)}function onSubmit(event){event.preventDefault(),window.clearTimeout(inputTimer),searchNow()}function onMore(){limit+=batch,render()}function onTag(event){var link=event.target.closest("[data-aa-tag]");!link||!ready||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey||(event.preventDefault(),window.clearTimeout(inputTimer),state={tag:link.dataset.aaTag,category:"",query:""},search.value="",limit=initial,saveState(!0),render(),root.scrollIntoView({behavior:window.matchMedia("(prefers-reduced-motion: reduce)").matches?"instant":"smooth",block:"start"}),heading&&(heading.tabIndex=-1,heading.focus({preventScroll:!0})))}function onClearTag(){state.tag="",limit=initial,saveState(!0),render()}function onPopState(){ready&&(readState(),limit=initial,render())}function destroy(){destroyed=!0,controller&&controller.abort(),window.clearTimeout(inputTimer),alignmentFrame!==null&&window.cancelAnimationFrame(alignmentFrame),alignmentObserver&&alignmentObserver.disconnect(),window.removeEventListener("resize",scheduleAlignment),document.fonts&&document.fonts.removeEventListener("loadingdone",scheduleAlignment),tabs.removeEventListener("click",onCategory),tagsNode.removeEventListener("click",onTag),search.removeEventListener("focus",onFocus),search.removeEventListener("blur",onBlur),search.removeEventListener("input",onInput),form.removeEventListener("submit",onSubmit),more.removeEventListener("click",onMore),retry.removeEventListener("click",load),clearTag&&clearTag.removeEventListener("click",onClearTag),window.removeEventListener("popstate",onPopState),instances.delete(root)}tabs.addEventListener("click",onCategory),tagsNode.addEventListener("click",onTag),search.addEventListener("focus",onFocus),search.addEventListener("blur",onBlur),search.addEventListener("input",onInput),form.addEventListener("submit",onSubmit),more.addEventListener("click",onMore),retry.addEventListener("click",load),clearTag&&clearTag.addEventListener("click",onClearTag),window.addEventListener("popstate",onPopState),instances.set(root,{destroy}),window.addEventListener("resize",scheduleAlignment),alignmentObserver&&alignmentObserver.observe(grid),document.fonts&&(document.fonts.addEventListener("loadingdone",scheduleAlignment),document.fonts.ready.then(scheduleAlignment)),load()}function initAll(scope){scope.matches&&scope.matches("[data-km-recommended-browser]")&&init(scope),scope.querySelectorAll("[data-km-recommended-browser]").forEach(init)}window.KMStorefrontSpeed.startEarly("[data-km-recommended-browser]",initAll);document.readyState==="loading"?document.addEventListener("DOMContentLoaded",function(){initAll(document)}):initAll(document),document.addEventListener("shopify:section:load",function(event){initAll(event.target)}),document.addEventListener("shopify:section:unload",function(event){var scope=event.target,roots=scope.matches&&scope.matches("[data-km-recommended-browser]")?[scope]:scope.querySelectorAll("[data-km-recommended-browser]");Array.prototype.forEach.call(roots,function(root){var instance=instances.get(root);instance&&instance.destroy()})})})();
//# sourceMappingURL=/cdn/shop/t/188/assets/replit-blog-article-hub-recommended.js.map?v=145620723546265931741791345880
